var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.300781 4C0.300781 2.06701 1.86779 0.5 3.80078 0.5H17.8008C19.7338 0.5 21.3008 2.06701 21.3008 4V18C21.3008 19.9331 19.7338 21.5 17.8008 21.5H3.80078C1.86779 21.5 0.300781 19.9331 0.300781 18V4ZM13.1341 13.3333C13.1341 12.689 13.6564 12.1667 14.3008 12.1667H18.9674V4C18.9674 3.35567 18.4451 2.83333 17.8008 2.83333H3.80078C3.15645 2.83333 2.63411 3.35567 2.63411 4V12.1667H7.30078C7.94511 12.1667 8.46745 12.689 8.46745 13.3333C8.46745 14.622 9.51208 15.6667 10.8008 15.6667C12.0895 15.6667 13.1341 14.622 13.1341 13.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealer);
export default __webpack_public_path__ + "static/media/dealer.ce72091e838830b12a675b4ad7e95c81.svg";
export { ForwardRef as ReactComponent };